import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { HelmetProvider } from 'react-helmet-async';
import SitePageContainer from './container/SitePageContainer';
import React from 'react';
function App() {
    return (_jsx(HelmetProvider, { children: _jsx(SitePageContainer, {}) }));
}
export default App;
